import * as trustScoreThresholds from '@/constants/trustScoreThresholds';

export const trustScoreRank = (score, lowerCase = true) => {
  let rank;
  if (score <= trustScoreThresholds.LOW) rank = 'Low';
  else if (score >= trustScoreThresholds.HIGH) rank = 'High';
  else rank = 'Medium';

  return lowerCase ? rank.toLowerCase() : rank;
};

export const analystTrustScoreRank = (score, lowerCase = true) => {
  let rank;
  if (score <= trustScoreThresholds.ANALYST_LOW) rank = 'Low';
  else if (score >= trustScoreThresholds.ANALYST_HIGH) rank = 'High';
  else rank = 'Medium';

  return lowerCase ? rank.toLowerCase() : rank;
};
